import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PERMISSIONS } from "./permissions-map";

const hasPermission = ({ permissions, scopes }) => {
  const scopesMap = {};
  scopes.forEach((scope) => {
    scopesMap[scope] = true;
  });

  return permissions?.some((permission) => scopesMap[permission]);
};

export default function PermissionsGate({
  children,
  scopes = [],
  isAutoRedirect = false,
}) {
  const navigate = useNavigate();
  const { role } = useSelector((store) => store.global.user);
  const permissions = PERMISSIONS[role];

  const permissionGranted = hasPermission({ permissions, scopes });

  if (!permissionGranted) {
    // If flag is true then it will redirect back to dashboard
    if (isAutoRedirect) {
      return navigate("/");
    }
    return <></>;
  }

  return <>{children}</>;
}
